import { render, staticRenderFns } from "./PurchasePrice.vue?vue&type=template&id=f30a58f8&"
import script from "./PurchasePrice.vue?vue&type=script&lang=js&"
export * from "./PurchasePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports